  <template>
    <div v-if="visible">
      <div class="flag-box">
        <img src="/images/img-2.png" />
      </div>
      <div class="info-container">
        <h6>尊敬的用户，您已完成认证</h6>
        <p class="sub">正在为您重新评估额度...</p>
        <div class="group-3">
          <div class="item">
            <i></i>
            <div class="text-wrapper">
              <img src="/images/icon-t1.png" />
              <span>基本信息</span>
            </div>
          </div>
          <div class="item">
            <i></i>
            <div class="text-wrapper">
              <img src="/images/icon-t1.png" />
              <span>身份信息</span>
            </div>
          </div>
          <div class="item">
            <i></i>
            <div class="text-wrapper">
              <img src="/images/icon-t1.png" />
              <span>匹配资方</span>
            </div>
          </div>
        </div>
      </div>
      <div class="predict-time">预计等待时间：{{ countdown }}s</div>
    </div>
  </template>

<script>
export default {
  name: "MideelApply",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countdown: 6,
      countdownTimer: null,
      forceKeep: true, // 强制至少展示到 countdown >= TempTime
      TempTime: 4,
    };
  },
  created() {
    this.startCountdown();
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // 打开时：重启倒计时，开启保护
        this.startCountdown();
        this.forceKeep = true;
      } else {
        // 父组件要求关闭
        if (this.countdown > this.TempTime) {
          this.forceKeep = true;
        } else {
          this.isOpen = false
          this.close();
        }
      }
    },
  },
  methods: {
    startCountdown() {
      this.clearTimer();
      this.countdown = 6;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= this.TempTime&&this.forceKeep) {
          this.forceKeep = false;
          this.close();
        }
        if (this.countdown <= 0) {
          this.close();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    close() {
      this.$emit("end", false);
      this.clearTimer();
    },
  },
  computed: {
    visible() {
      // 控制显示逻辑：父组件 isOpen=true 或者正在强制保持
      return this.isOpen || this.forceKeep;
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
};

</script>

<style lang="less" scoped>
.flag-box {
  margin-top: 50px;
  text-align: center;

  img {
    width: 90px;
    height: 90px;
    background-size: 100% 100%;
  }
}

.info-container {
  margin-top: 36px;
  border-radius: 16px;
  border: 4px solid #b9ddf2;
  background: #b9ddf2;
  box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);

  h6 {
    color: #254774;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
    padding: 20px 0 16px 0;
  }

  .sub {
    color: #254774;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .group-3 {
    margin-top: 12px;
    border-radius: 16px;
    background: #fafdff;
    box-shadow: 0 4px 13.5px 2px rgba(0, 0, 0, 0.02);
    padding: 20px 0;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .item {
      display: flex;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      i {
        display: block;
        background-image: url("/images/icon-loading.png");
        background-repeat: no-repeat;
        width: 24px;
        height: 24px;
        margin-right: 8px;
        animation: rotate 1s linear infinite; // 3 秒转一圈
      }

      .text-wrapper {
        width: 133px;
        height: 32px;
        border-radius: 16px;
        background: rgba(185, 221, 242, 0.4);
        padding: 4px;
        display: flex;
        align-items: center;

        img {
          width: 26px;
          height: 26px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }

        span {
          margin-left: 20px;
          color: #254774;
          font-size: 15px;
          font-style: normal;
          font-weight: 500;
        }
      }
    }
  }
}

.predict-time {
  margin-top: 26px;
  color: rgba(37, 71, 116, 0.6);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>